import React from 'react';
import { ReactComponent as SearchIcon } from "../../../design-system/design_system/assets/icons/system/search.svg";
const FauxTypeAhead =   ({typeAheadSearchLabelTxt,handleFauxSearchfunc}) => {

    const handleAccessibilitySearchfunc = (e) =>{
        var code = e.keyCode || e.which;
        if( code === 13 ) {
            handleFauxSearchfunc();
        }
        else return false;
    }
   
    return (
            <li tabIndex="0" data-testid = "type-ahead-search-container" className="type-ahead-btn" onClick={handleFauxSearchfunc} onKeyDown={handleAccessibilitySearchfunc}>
                <span className="type-ahead-input" aria-label={typeAheadSearchLabelTxt.InputDefaultText}>{typeAheadSearchLabelTxt.InputDefaultText}</span>
                <span className="type-ahead-faux-btn" tabIndex="0">
                    <SearchIcon className="svg-fill-black"/>
                </span>
            </li>
         
            
    )
}

export default FauxTypeAhead;
